<template>
  <div class="l-info-num-card" :class="type">
      <div class="img">
          <l-img :src='src'></l-img>
      </div>
      
      <div class="info">

        <div class="num">
        {{_num}}    
        </div>
        
        <div class="text">

            <div class="header">
                <h1 class="title">
                    {{title}}
                </h1>
                <h4 class="sub-title">
                    {{subTitle}}
                </h4>
            </div>

            
            <l-info-column  v-bind='info'>
            </l-info-column>
            
        </div>  
      </div>
      
  </div>
</template>

<script>
export default {
    name: 'l-info-num-card',
    props:{
        type: {
            default: 'left'
        },
        title: {
           default: '' 
        },
        subTitle: {
            default: ''
        },
        info:{
            default(){return {}}
        },
        num: {
            default: 0
        },
        src: {
            default: ''
        }
    },
    computed:{
        _num(){
            return this.num >= 10 ? this.num : `0${this.num}`
        }
    }

}
</script>
<style lang="scss" scoped>

$numW: 46px;
$imgW: 300px;


.l-info-num-card{
    box-sizing: border-box;
    height: 300px;

    &.right{

        .info{
            margin-right: 0;
            margin-left: $imgW;
        }

        .num{
            float: right;
        }
        
        .img{
            float: left;
        }
    }
}


.info{
    box-sizing: border-box;
    margin-right: $imgW;
    height: 100%;

    .header{
        margin-bottom: 30px;
    }

    .num{
        float: left;
        position: relative;
        width: $numW;
        height: 100%;
        font-size: 42px;
        color: $color_8;

        &::after{
            content: '';
            position: absolute;
            top: 120px;
            left: 0;
            right: 0;

            margin: auto;
            width: 2px;
            height: 100px;
            background: $color_8;
        }
    }


    .text{
        box-sizing: border-box;
        padding: 40px 100px;
        width: 600px;
    }
    
    .title{
        @include font_sub_title;
        margin-bottom: 10px;
    }
    .sub-title{
    @include font_content;   
    }

}



.img{
    float: right;
    width: $imgW;
    height: 100%;
}



</style>